module.exports = __webpack_public_path__ + "img/唐门男.4aa07dc3.png";